module.exports = __webpack_public_path__ + "img/stijlen-sporty.06a92691.png";